import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(no-auth)/error.tsx")